import ThisModule from "./DeleteAccountSection";

export default ThisModule;
